"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _reactHookForm = require("react-hook-form");

var _styledComponents = require("styled-components");

var _TextInputButton = require("./TextInputButton.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/jsx-props-no-spreading */
var TextInputButton = function TextInputButton(_ref) {
  var buttonColor = _ref.buttonColor,
      _ref$buttonLabel = _ref.buttonLabel,
      buttonLabel = _ref$buttonLabel === void 0 ? 'Submit' : _ref$buttonLabel,
      className = _ref.className,
      id = _ref.id,
      inputLabel = _ref.inputLabel,
      isLoading = _ref.isLoading,
      onSubmit = _ref.onSubmit,
      type = _ref.type,
      validations = _ref.validations,
      value = _ref.value;
  var methods = (0, _reactHookForm.useForm)({
    mode: 'onBlur'
  });
  var errors = methods.errors,
      handleSubmit = methods.handleSubmit,
      register = methods.register,
      setValue = methods.setValue;
  var fieldErrors = errors[id];

  var onError = function onError() {
    return null;
  };

  (0, _react.useEffect)(function () {
    setValue(id, value);
  }, [id, setValue, value]);
  return /*#__PURE__*/_react["default"].createElement(_reactHookForm.FormProvider, methods, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit(onSubmit, onError),
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_TextInputButton.StyledContainer, null, /*#__PURE__*/_react["default"].createElement(_TextInputButton.StyledInputContainer, null, /*#__PURE__*/_react["default"].createElement(_TextInputButton.StyledInput, {
    id: id,
    name: id,
    placeholder: inputLabel,
    ref: register(validations),
    type: type
  })), /*#__PURE__*/_react["default"].createElement(_TextInputButton.StyledButton, {
    color: buttonColor,
    isLoading: isLoading,
    label: buttonLabel,
    size: "small",
    type: "submit"
  })), fieldErrors && /*#__PURE__*/_react["default"].createElement(_TextInputButton.StyledTextInputError, {
    "data-id": "field-error"
  }, fieldErrors.message)));
};

TextInputButton.defaultProps = {
  buttonColor: 'primary',
  buttonLabel: 'Submit',
  className: undefined,
  inputLabel: undefined,
  isLoading: false,
  type: 'text',
  validations: undefined,
  value: ''
};
TextInputButton.propTypes = {
  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** The color of the button based on the theme */
  buttonColor: (0, _propTypes.oneOf)(['primary', 'secondary', 'tertiary']),

  /** Label of the submission button */
  buttonLabel: _propTypes.string,

  /** Unique identitier of the input */
  id: _propTypes.string.isRequired,

  /** If true, spinner will be presented. */
  isLoading: _propTypes.bool,

  /** Label of the text input */
  inputLabel: _propTypes.string,

  /** Function to be called upon submission */
  onSubmit: _propTypes.func.isRequired,

  /** Type of the Text Input */
  type: (0, _propTypes.oneOf)(['email', 'number', 'tel', 'text']),

  /** Validations to be provided for the component. */
  validations: (0, _propTypes.shape)({
    required: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
    max: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    maxLength: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    min: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    minLength: (0, _propTypes.shape)({
      value: _propTypes.number,
      message: _propTypes.string
    }),
    pattern: (0, _propTypes.shape)({
      value: (0, _propTypes.instanceOf)(RegExp),
      message: _propTypes.string
    }),
    validate: (0, _propTypes.shape)({})
  }),

  /** Initial value */
  value: _propTypes.string
};
TextInputButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TextInputButton",
  "props": {
    "buttonLabel": {
      "defaultValue": {
        "value": "'Submit'",
        "computed": false
      },
      "description": "Label of the submission button",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "buttonColor": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "description": "The color of the button based on the theme",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }, {
          "value": "'tertiary'",
          "computed": false
        }]
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "inputLabel": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Label of the text input",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isLoading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, spinner will be presented.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'text'",
        "computed": false
      },
      "description": "Type of the Text Input",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'email'",
          "computed": false
        }, {
          "value": "'number'",
          "computed": false
        }, {
          "value": "'tel'",
          "computed": false
        }, {
          "value": "'text'",
          "computed": false
        }]
      },
      "required": false
    },
    "validations": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Validations to be provided for the component.",
      "type": {
        "name": "shape",
        "value": {
          "required": {
            "name": "union",
            "value": [{
              "name": "bool"
            }, {
              "name": "string"
            }],
            "required": false
          },
          "max": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "maxLength": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "min": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "minLength": {
            "name": "shape",
            "value": {
              "value": {
                "name": "number",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "pattern": {
            "name": "shape",
            "value": {
              "value": {
                "name": "instanceOf",
                "value": "RegExp",
                "required": false
              },
              "message": {
                "name": "string",
                "required": false
              }
            },
            "required": false
          },
          "validate": {
            "name": "shape",
            "value": {},
            "required": false
          }
        }
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Initial value",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "id": {
      "description": "Unique identitier of the input",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "onSubmit": {
      "description": "Function to be called upon submission",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(TextInputButton);

exports["default"] = _default;